<template>
    <div class="card" style="margin-top: 40px;">
        <div class="card-header">
            <h3 class="card-title">Estimator Setup</h3>
            <button @click="closeModal" class="closeIcon" style="width: 40px;height: 40px;"><span></span></button>
        </div>
        <div class="card-body" style="padding: 10px 5px;">
            <div class="container">
                <button class="btn btn-primary" @click="openModal"><i class="fas fa-plus"></i> Categorized</button>
            </div>
        </div>
        <modal name="addCategrized" :resizable="false" :adaptive="true" @before-close="resetModalAddCategorized">
            <addCategrized></addCategrized>
        </modal>
    </div>
</template>
<script>
import addCategrized from './addCategrized.vue';
export default {
    name: 'estimatorSetup',
    components: {
        addCategrized
    },
    data() {
        return {
            // Add any data properties needed for the estimator setup
        };
    },
    methods: {
        // Define methods for handling estimator setup logic
        closeModal() {
            // Logic to save settings
            this.$parent.$emit('closed-lateral');
        },
        openModal() {
            this.$modal.show('addCategrized', {
                title: 'Add Categorized Estimator',
                data: {}
            }, {
                width: '400px',
                height: '500px',
                zIndex: '9999'
            });
        },
        resetModalAddCategorized() {
            console.log('resetModalAddCategorized');
        }
    }
}
</script>
<style lang="scss" scoped>
.closeIcon span:before,
.closeIcon span:after {
    width: 37px;
}

</style>
